import React, { useEffect, useRef } from "react";
import { Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Button } from '@/Components/ui';
;
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast, { Toaster } from 'react-hot-toast';
import { read, utils, writeFileXLSX, writeFile } from "xlsx";
import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import { API_RESERVATION_GIFTS, changeReservationState, deleteReservationGiftItem, getDataFromUrl } from "../../../api";
import moment from "moment";
import { dialogService } from "@/utils/dialogService";
function printDiv(elid) {
    var divContents = document.getElementById(elid).innerHTML;
    var a = window.open("", "", "height=700, width=500");
    a.document.write("<html>");
    a.document.write('<body><table class="custom-header-css table">');
    a.document.write(divContents);
    // console.log(divContents)
    a.document.write("</table></body></html>");
    a.document.close();
    a.print();
}
const ReservationGiftList = () => {
    const navigate = useNavigate();
    const selectReservationState = [
        { label: "예약", value: "예약" }, // 구입후 기본 상태
        { label: "입장", value: "입장" }, // 예약날짜에 와서 입장한 상태
        { label: "외출", value: "외출" }, // 입장후 잠시 외출한 상태
        { label: "퇴장", value: "퇴장" },
        { label: "완료", value: "완료" }, // 사용 완료한 상태. 입장상태에서 날짜가 지나면 완료로 바꿈
        { label: "노쇼", value: "노쇼" }, // 예약날짜에 나타나지 않아서 환불도 불가한 상태
    ];
    const columns = React.useMemo(() => [
        {
            Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()}/>,
            Cell: (cellProps) => {
                return <input type="checkbox" className="customerCheckBox form-check-input" value={cellProps.row.original.id}/>;
            },
            id: "#",
        },
        //   {
        //     Header: 'ID',
        //     accessor: 'id',
        //     id: 'id',
        //   },
        {
            Header: "예약ID",
            accessor: "reserv_id",
            id: "reserv_id",
        },
        {
            Header: "예약신청일",
            accessor: "reservationDate",
            id: "reservationDate",
        },
        {
            Header: "선물일",
            accessor: "send_date",
            id: "send_date",
            Cell: (cellProps) => {
                return <span>{moment(cellProps.row.original["send_date"]).format("YYYY-MM-DD HH:mm")}</span>;
            },
        },
        {
            Header: "예약상품",
            accessor: "name",
            id: "name",
        },
        {
            Header: "자리",
            accessor: "spot",
            id: "spot",
        },
        {
            Header: "보낸이",
            accessor: "phone_num",
            id: "phone_num",
            Cell: (cellProps) => {
                return (<div>
              <div>{cellProps.row.original["sender"]}</div>
              <div>{cellProps.row.original["phone_num"]}</div>
            </div>);
            },
        },
        {
            Header: "받는이",
            accessor: "recipient_phone_num",
            id: "recipient_phone_num",
            Cell: (cellProps) => {
                return (<div>
              <div>{cellProps.row.original["recipient"]}</div>
              <div>{cellProps.row.original["recipient_phone_num"]}</div>
            </div>);
            },
        },
        {
            Header: "선물상태",
            accessor: "gift_state",
            id: "gift_state",
        },
        {
            Header: "예약상태",
            accessor: "reserv_state",
            id: "reserv_state",
            Cell: (cellProps) => {
                const selref = useRef(null);
                useEffect(() => {
                    if (selref) {
                        selref.current.setValue(selectReservationState.find((val) => {
                            return cellProps.row.original["reserv_state"].valueOf() === val.value.valueOf();
                        }), "deselect-option");
                    }
                }, [cellProps, selref]);
                return (<>
              <Select ref={selref} className="mb-0" defaultValue={selectReservationState.find((val) => {
                        return cellProps.row.original["reserv_state"].valueOf() === val.value.valueOf();
                    })} onChange={(val) => {
                        if (cellProps.row.original["reserv_state"].valueOf() === val.value.valueOf())
                            return;
                        changeReservationState(cellProps.row.original.reserv_id, val.value).then((data) => {
                            console.log("changeReservationState", data);
                            toast.success(`예약상태를 변경하였습니다!\n : ${cellProps.row.original["reserv_state"]}=>${val.value}`, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                        });
                    }} options={selectReservationState} id={"choices-single-" + cellProps.row.original.id}></Select>
            </>);
            },
        },
        {
            Header: "Actions",
            accessor: "Actions",
            id: "",
            Cell: (cellProps) => {
                return (<div className="d-flex gap-2">
              {/* <div className="edit">
                      <div className="text-primary" style={{cursor: "pointer"}} onClick={() => {}}>
                        <i className="ri-pencil-fill fs-16"></i>
                      </div>
                    </div> */}
              <div className="remove">
                <div className="text-danger" style={{ cursor: "pointer" }} onClick={() => {
                        onClickDelete(cellProps.row.original.id);
                    }}>
                  <i className="ri-delete-bin-5-fill fs-16"></i>
                </div>
              </div>
            </div>);
            },
        },
    ], []);
    // const [modal, setModal] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [previous, setPrevious] = React.useState("");
    const [next, setNext] = React.useState("");
    const [count, setCount] = React.useState("");
    const [dataQuery, setDataQuery] = React.useState({});
    const onRequestData = (_url) => {
        getDataFromUrl(_url)
            .then((data) => {
            setData(data.results);
            setPrevious(data.previous);
            setNext(data.next);
            setCount(data.count);
            // if (isSearch) calcTotalPageCount(data.count, (data.results).length);
        })
            .catch((e) => {
            console.log(e);
        });
    };
    React.useEffect(() => {
        if (!previous && !next) {
            getDataFromUrl(API_RESERVATION_GIFTS)
                .then((data) => {
                console.log("getDataFromUrl", data);
                setData(data.results);
                setPrevious(data.previous);
                setNext(data.next);
                setCount(data.count);
            })
                .catch((e) => {
                console.log(e);
            });
        }
    }, []);
    const refetchData = () => {
        getDataFromUrl(API_RESERVATION_GIFTS)
            .then((data) => {
            console.log("getDataFromUrl", data);
            setData(data.results);
            setPrevious(data.previous);
            setNext(data.next);
            setCount(data.count);
        })
            .catch((e) => {
            console.log(e);
        });
    };
    const [checkedRecords, setCheckedRecords] = React.useState([]);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [deleteModalMulti, setDeleteModalMulti] = React.useState(false);
    const checkedAll = () => {
        const checkall = document.getElementById("checkBoxAll");
        const ele = document.querySelectorAll(".customerCheckBox");
        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        }
        else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
    };
    // const clearSelectedOptions = () => {
    //   const ele = document.querySelectorAll(".customerCheckBox:checked");
    //   const checkall = document.getElementById("checkBoxAll");
    //   ele.forEach((element) => {
    //     element.checked = false;
    //   })
    //   checkall.checked = false;
    //   // setFocusState(-1);
    // }
    // const changeCheckedRecords = () => {
    //   const ele = document.querySelectorAll(".customerCheckBox:checked");
    //   let checked = []
    //   try {
    //     ele.forEach((element) => {
    //       let tmpArr = data.filter((voucher) => (voucher.id).toString() === element.value.toString());
    //       let obj = tmpArr[0];
    //       checked.push(obj);
    //     })
    //   } catch (error) {
    //     console.log(error)
    //   }
    //   // console.log("changeCheckedRecords", checked)
    //   setCheckedRecords(checked);
    // }
    const deleteRecords = async () => {
        const ele = document.querySelectorAll(".customerCheckBox:checked");
        const checkall = document.getElementById("checkBoxAll");
        if (ele.length === 0) {
            await dialogService.handleAlert("삭제할 항목이 없습니다.");
            return;
        }
        ele.forEach((element) => {
            console.log("reservation id:", element.value);
            deleteReservationGiftItem(element.value)
                .then((data) => {
                console.log("deleteReservationGiftItem:", data);
                if (data) {
                    // alert("삭제되었습니다.");
                    refetchData();
                }
            })
                .catch((e) => {
                console.warn(e);
            });
            element.checked = false;
        });
    };
    const onClickDelete = (order) => {
        setCheckedRecords([order]);
        setDeleteModal(true);
    };
    const handleDeleteOrder = () => {
        if (checkedRecords.length) {
            checkedRecords.forEach((value) => {
                console.log("reservation id:", value);
                deleteReservationGiftItem(value)
                    .then(async (data) => {
                    console.log("deleteReservationGiftItem2:", data);
                    if (data) {
                        await dialogService.handleAlert("삭제되었습니다.");
                        refetchData();
                    }
                })
                    .catch((e) => {
                    console.warn(e);
                });
            });
            setDeleteModal(false);
        }
    };
    return (<div className="page-content">
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteOrder} onCloseClick={() => setDeleteModal(false)}/>
      <DeleteModal show={deleteModalMulti} onDeleteClick={() => {
            deleteRecords();
            setDeleteModalMulti(false);
        }} onCloseClick={() => setDeleteModalMulti(false)}/>
      <Container fluid>
        <BreadCrumb title="예약(선물)관리" pageTitle="예약"/>
        <Row>
          <Col lg={12}>
            <Card id="orderList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">예약 (선물) 목록</h5>
                  <div className="flex-shrink-0">
                    {/* <Button
          onClick={() => {
            dialogService.notifyInfo("액셀 파일을 다운로드합니다... 건수가 400건이 넘을 경우 파일에 누락될 수 있으니 유의하시기 바랍니다.")
            getDataFromUrl(`${API_RESERVATION_ALL}/?${QueryString.stringify(dataQuery)}`).then((data)=>{
              // const rows = data.map(row => ({
              // // id	예약신청일	예약상품	자리	예약자	번호	예약시작일	이용기간	예약상태	결제상태	승인번호
              // }));
              const worksheet = utils.json_to_sheet(data);
              const workbook = utils.book_new();
              utils.book_append_sheet(workbook, worksheet, "id");
              writeFileXLSX(workbook, "output.xlsx")
            })
          }} color="soft"><i className="ri-save-2-line"></i></Button>
        <span style={{ padding: "4px" }}></span> */}
                    <Button onClick={() => {
            printDiv("reservations-table");
        }} color="soft">
                      <i className="ri-printer-line"></i>
                    </Button>
                    <span style={{ padding: "4px" }}></span>
                    <Button onClick={() => setDeleteModalMulti(true)} color="soft-danger">
                      <i className="ri-delete-bin-2-line"></i>
                    </Button>
                  </div>
                </div>
              </CardHeader>

              <CardBody className="pt-0 px-2">
                <div className="card-body pt-0 px-2">
                  <div>
                    <React.Fragment>
                      <ServerPaginatedTable id="reservations-table" url={API_RESERVATION_GIFTS} columns={columns} data={data} previous={previous} next={next} count={count} onRequestData={onRequestData} onChangeQuery={setDataQuery} categories={[
        //   { id: 0, title: "전체", state: "", icon: "ri-store-2-fill" },
        //   { id: 1, title: "예약완료", state: "예약완료", icon: "ri-checkbox-circle-line" },
        //   { id: 2, title: "입금대기", state: "입금대기", icon: "ri-more-fill" },
        //   { id: 3, title: "결제대기", state: "결제대기", icon: "ri-arrow-left-right-fill" },
        // { id: 4, title: "취소완료", state: "취소완료", icon: "ri-arrow-left-right-fill" },
        ]}/>
                    </React.Fragment>
                  </div>
                </div>

                <Toaster position="top-center"/>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>);
};
export default ReservationGiftList;
